<div>
  <div *ngFor="let field of field.fieldGroup; let i = index">
     <formly-field [field]="field"></formly-field>
  </div>
</div>